// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-Messages-styles-__go-back-button__wrapper--2jxoM","button":"src-components-Messages-styles-__go-back-button__button--3KSAA","label":"src-components-Messages-styles-__go-back-button__label--uNIRl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Messages/styles/go-back-button.css
// module id = 1977
// module chunks = 0